import Vue from "vue";
import enUS from "@kangc/v-md-editor/lib/lang/en-US";
import VueMarkdownEditor from "@kangc/v-md-editor";
// import vuepressTheme from "@kangc/v-md-editor/lib/theme/vuepress.js";
import githubTheme from "@kangc/v-md-editor/lib/theme/github.js";

VueMarkdownEditor.use(githubTheme);
VueMarkdownEditor.lang.use("en-US", enUS);
Vue.use(VueMarkdownEditor);
